import { APPLICANT_FORM_FIELD_ORDER } from '../../RentalPortalApplicantForm.constants'

export function getApplicantFormFirstErrorField(errors) {
  return APPLICANT_FORM_FIELD_ORDER.find(name => errors[name])
}
